import { Routes } from '@angular/router';
import { MembersType01Component } from './members-type01/members-type01.component';

export default [
    {
        path     : '',
        component: MembersType01Component,
    },
    
] as Routes;
